import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import FormSpinner from '../../common/utility/FormSpinner';
import * as registerFormActions from '../../../store/actions/register-form-actions';
import { formMessageConstants } from '../../utils/constants/form-message-constants';
import FormMessage from '../../common/utility/FormMessage';
import RegisterFormBanner from '../one-club-register/RegisterFormBanner';

function UserRegisterSuccessForm({
    onSignIn,
    onBallotSignIn,
    actions,
    emailAddress,
    ssoDomain,
    isBallotRegister,
    loading,
    isResendEmailVerificationSuccessful,
    resendEmailVerificationMessages,
    requestEmailVerificationCallbackUrl,
    actionSuccessText,
    requestEmailVerificationActionSuccessText,
    displayBanner,
    bannerBackgroundImageSrc,
    bannerSuccessRegistration
}) {
    function onResendEmailVerification() {
        actions.resendEmailVerification({
            emailAddress,
            ssoDomain,
            callBackUrl: requestEmailVerificationCallbackUrl,
            actionSuccessText: requestEmailVerificationActionSuccessText
        });
    }

    if (isEmpty(bannerBackgroundImageSrc)) {
        displayBanner = false;
    }

    if (bannerSuccessRegistration &&
        bannerSuccessRegistration.bannerBackgroundImageSrc !== null &&
        bannerSuccessRegistration.bannerBackgroundImageSrc !== undefined &&
        bannerSuccessRegistration.bannerBackgroundImageSrc.length !== 0) {
        displayBanner = true;
    }

    let formBanner = {};
    if (bannerSuccessRegistration &&
        bannerSuccessRegistration.bannerBackgroundImageSrc !== null &&
        bannerSuccessRegistration.bannerBackgroundImageSrc !== undefined &&
        bannerSuccessRegistration.bannerBackgroundImageSrc.length !== 0) {
        formBanner = {
            bannerTitle: bannerSuccessRegistration.bannerTitle,
            bannerMessage: '',
            bannerBackgroundImageSrc: bannerSuccessRegistration.bannerBackgroundImageSrc,
            displayMessageUnderImage: false,
            displayHeadingOverImage: true,
            headingColor: bannerSuccessRegistration.headingColor,
            textColor: 'black'
        };
    } else {
        formBanner = {
            bannerTitle: '',
            bannerMessage: '',
            bannerBackgroundImageSrc,
            displayMessageUnderImage: false,
            displayHeadingOverImage: false,
            headingColor: 'white',
            textColor: 'black'
        };
    }

    return (
        <div className='form-popup' >
            {loading ? <FormSpinner>/</FormSpinner> : null}
            {displayBanner ? <RegisterFormBanner
                formBanner={formBanner}
            ></RegisterFormBanner> : null}
            <section className='form-popup__content'>
                <FormMessage
                    isSuccessMessage={isResendEmailVerificationSuccessful}
                    messages={resendEmailVerificationMessages}></FormMessage>
                <div className='pop-up-message'>{actionSuccessText || formMessageConstants.oneClubRegisterSuccessText}</div>
                <div className='pop-up-buttons'>
                    <div className='sign-in fs-14'>
                        <button
                            className='button button--primary auto-mt-md'
                            data-dc-component='modal-trigger-login'
                            onClick={isBallotRegister ? onBallotSignIn : onSignIn}
                        >
                            <span className='button-content button-content--icon'>
                                <span>{formMessageConstants.signInHere}</span>
                                <svg
                                    className='icon button__arrow-right'
                                    width='14'
                                    height='12'
                                    focusable='false'
                                >
                                    <use xlinkHref='#icon-arrow-right'></use>
                                </svg>
                            </span>
                        </button>
                    </div>
                    {emailAddress ? <div className='resend-email fs-14'>
                        <a
                            className='link'
                            href='#'
                            data-dc-component='modal-trigger-login'
                            onClick={onResendEmailVerification}
                        >
                            {formMessageConstants.resendVerificationEmail}
                        </a>
                    </div> : null}
                </div>
            </section>
        </div>
    );
}

UserRegisterSuccessForm.propTypes = {
    onSignIn: PropTypes.func.isRequired,
    onBallotSignIn: PropTypes.func.isRequired,
    emailAddress: PropTypes.string.isRequired,
    ssoDomain: PropTypes.string.isRequired,
    requestEmailVerificationCallbackUrl: PropTypes.string.isRequired,
    actionSuccessText: PropTypes.string.isRequired,
    requestEmailVerificationActionSuccessText: PropTypes.string.isRequired,
    displayBanner: PropTypes.bool.isRequired,
    isBallotRegister: PropTypes.bool.isRequired
};

function mapStateToProps(state) {
    return {
        loading: state.apiStatus.apiCallsInProgress > 0,
        isResendEmailVerificationSuccessful: state.registerForm.isResendEmailVerificationSuccessful,
        resendEmailVerificationMessages: state.registerForm.resendEmailVerificationMessages,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            resendEmailVerification: bindActionCreators(registerFormActions.resendEmailVerification, dispatch)
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(UserRegisterSuccessForm);
